export default __webpack_public_path__ + "static/media/questionnaires.df91d675.jpg";